import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { ScrollToTopProvider } from './ScrollToTop.context'

/**
 * The ScrollToTop' component.
 */
const ScrollToTop = props => {
  const { children } = props
  const { hash, pathname } = useLocation()

  useEffect(() => {
    if (hash) {
      return
    }

    window.scrollTo(0, 0)
  }, [pathname])

  return <ScrollToTopProvider>{children}</ScrollToTopProvider>
}

ScrollToTop.propTypes = {
  children: PropTypes.node.isRequired
}

export default ScrollToTop
